export default function*() {
  yield localStorage.clear()
}
